import Header from "../components/Header";

const LAST_UPDATED = "8 May 2026";

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-2xl font-black text-[#ffd978] mb-3">{title}</h2>
      <div className="space-y-3 text-white/75 leading-relaxed">{children}</div>
    </div>
  );
}

export default function CookiePolicy() {
  return (
    <main className="bg-[#050505] text-white">
      <Header />

      <section className="mx-auto max-w-4xl px-6 pt-36 pb-20 select-text">
        <p className="font-black uppercase text-[#ffb56f]">Legal</p>
        <h1 className="outfall-heading text-[clamp(48px,8vw,90px)] leading-none text-[#ffd978] drop-shadow-[0_0_18px_#ff8f6b]">
          Cookie Policy
        </h1>
        <p className="mt-4 text-white/40 font-bold">
          Last updated: {LAST_UPDATED}
        </p>

        <div className="mt-12 space-y-10">
          <p className="text-white/70 leading-relaxed">
            This Cookie Policy explains what cookies are, how Outfall uses them
            on <strong className="text-white/90">outfall.website</strong> and{" "}
            <strong className="text-white/90">outfall.co.uk</strong>, and what
            your options are. By using our website, you consent to the use of
            cookies as described in this policy.
          </p>

          <Section title="1. What Are Cookies">
            <p>
              Cookies are small text files placed on your device by a website
              when you visit. They are widely used to make websites function
              correctly, remember preferences, and provide information to site
              owners. Cookies do not contain executable code and cannot carry
              viruses.
            </p>
          </Section>

          <Section title="2. Cookies We Use">
            <p>
              We use a minimal number of cookies — only what is strictly
              necessary to operate the site. We do not use advertising,
              analytics, or tracking cookies.
            </p>

            <div className="mt-4 overflow-x-auto rounded-xl border border-[#ffb56f]/20">
              <table className="w-full text-sm">
                <thead className="bg-[#ffd978]/10 text-[#ffd978]">
                  <tr>
                    <th className="px-4 py-3 text-left font-black uppercase">
                      Name
                    </th>
                    <th className="px-4 py-3 text-left font-black uppercase">
                      Purpose
                    </th>
                    <th className="px-4 py-3 text-left font-black uppercase">
                      Duration
                    </th>
                    <th className="px-4 py-3 text-left font-black uppercase">
                      Type
                    </th>
                  </tr>
                </thead>
                <tbody className="text-white/70">
                  <tr className="border-t border-white/10">
                    <td className="px-4 py-3 font-mono text-white/90">sb-*</td>
                    <td className="px-4 py-3">
                      Supabase session token — keeps you logged in after
                      authenticating with Discord
                    </td>
                    <td className="px-4 py-3">3 days</td>
                    <td className="px-4 py-3">Strictly necessary</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p className="mt-3">
              The session cookie contains a randomly generated token, not your
              personal data. It is transmitted over HTTPS only and cannot be
              accessed by client-side scripts (HttpOnly).
            </p>
          </Section>

          <Section title="3. Third-Party Cookies">
            <p>
              We do not embed third-party advertising, social media widgets, or
              analytics scripts that would place additional cookies on your
              device.
            </p>
            <p>
              When you authenticate via Discord's OAuth2 service, Discord may
              set its own cookies on the discord.com domain. These are outside
              our control and governed by Discord's own Cookie Policy.
            </p>
          </Section>

          <Section title="4. Strictly Necessary Cookies">
            <p>
              The session cookie we use is strictly necessary for the website to
              function. Without it, features requiring authentication (career
              applications, ban appeals, admin panel) cannot work. Because this
              cookie is strictly necessary, we do not require your consent to
              set it under the UK GDPR exemption for essential cookies — however
              we are transparent about its use in this policy.
            </p>
          </Section>

          <Section title="5. Managing Cookies">
            <p>
              You can control and delete cookies through your browser settings.
              The following links explain how to manage cookies in common
              browsers:
            </p>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                <a
                  href="https://support.google.com/chrome/answer/95647"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#ffd978] underline"
                >
                  Google Chrome
                </a>
              </li>
              <li>
                <a
                  href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#ffd978] underline"
                >
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a
                  href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#ffd978] underline"
                >
                  Safari
                </a>
              </li>
              <li>
                <a
                  href="https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-168dab11-0753-043d-7c16-ede5947fc64d"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#ffd978] underline"
                >
                  Microsoft Edge
                </a>
              </li>
            </ul>
            <p>
              Please note that disabling the session cookie will prevent you
              from logging in to any authenticated features of the website.
            </p>
          </Section>

          <Section title="6. Changes to This Policy">
            <p>
              We may update this Cookie Policy from time to time. The "Last
              updated" date at the top of this page reflects the most recent
              revision. Continued use of the website after any update
              constitutes acceptance of the revised policy.
            </p>
          </Section>

          <Section title="7. Contact">
            <p>
              If you have any questions about our use of cookies, contact us
              through our official Discord server or at{" "}
              <strong className="text-white/90">outfall.website</strong>.
            </p>
          </Section>
        </div>
      </section>
    </main>
  );
}
